const React = require("react");

require("./QuestionUpdateError.less");

const ErrorPropType = require("~/types/Error.js").PropType;

const QuestionUpdateError = React.createClass({
    propTypes: {
        Error: ErrorPropType.isRequired
    },
    render() {
        const response = this.GetResponse();

        return (<figure className="cs-QuestionUpdateError">
            <div className="cs-QuestionUpdateError__left-box">
                <span className="glyphicon glyphicon-exclamation-sign"></span>
            </div>
            <div className="cs-QuestionUpdateError__right-box">
                An error occurred during the update.  Please contact support with the following details:
                <hr />
                Message: {this.props.Error.message}
                {response}
            </div>
        </figure>);
    },
    GetResponse() {
        if (this.props.Error.response) {
            return (<p className="cs-QuestionUpdateError__response">
                {this.props.Error.response.status} - {this.props.Error.response.statusText} - {this.props.Error.response.url}
            </p>);
        }

        return null;
    }
});

module.exports = QuestionUpdateError;


// WEBPACK FOOTER //
// ./src/components/QuestionUpdateError/QuestionUpdateError.jsx